// CRITICAL: Import and set up Buffer FIRST, before any other imports
// This ensures Buffer is available when lazy-loaded chunks (csv-parse, xlsx, mammoth) load
import { Buffer } from 'buffer';

// Set Buffer globally immediately - must be done before React or any other imports
if (typeof window !== 'undefined') {
    window.Buffer = Buffer;
    window.global = window;
}
if (typeof globalThis !== 'undefined') {
    globalThis.Buffer = Buffer;
}
if (typeof global !== 'undefined') {
    global.Buffer = Buffer;
}

import ReactDOM from 'react-dom/client'
import store from './redux';
import App from './App'
import { Provider } from 'react-redux';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <Provider store={store}>
        <App />
    </Provider>
)
